module.exports = __webpack_public_path__ + "static/cfg-poster-2025-48af1fd1404e0b632b6aaae2d13a49a8.png";